import { MultiSetSubTreeBuilder } from "../../General/Tree/MultiSet/multi-set-sub-tree-builder";
import { Node } from "../../General/graph/lib/node";
import { MultiSetTreeNode } from "../../General/Tree/MultiSet/multi-set-tree-node";

export class SubTreeWords extends MultiSetSubTreeBuilder {
    protected activ: boolean = false;
    subNodeMode: boolean = false;
    hideContentMode: boolean = false;

    setHiddenNodes(content: any[][]){
        content.forEach(c => {
            this.nodes.forEach(node => {
                if(node instanceof MultiSetTreeNode){
                    if(this.equalContent(node.getContent(), c)){
                        node.setHidden(true);
                    }
                }
            })
        })
    }

    getRoot():MultiSetTreeNode{
        return this.root;
    }

    getHiddenNodes(): any[][]{
        let content: any[][] = [];
        this.nodes.forEach(node => {
            if(node instanceof MultiSetTreeNode){
                if(node.isHidden()){
                    content.push(node.getContent());
                }
            }
        })
        return content;
    }
    
    disable() {
        this.activ = false;
    }
    enable() {
        this.activ = true;
    }
    doubleClick() {
        return;
    }
    keyboardEvent() {}

    leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        if (!this.activ) {
            return;
        }
        let clickedNode: MultiSetTreeNode = null;
        this.nodes.forEach(n => {
            if (n.inParameter(e, this.grid)) {
                if (n instanceof MultiSetTreeNode) {
                    clickedNode = n;
                }
            }
        })

        if (clickedNode == null || this.root == null) {
            return;
        }

        //console.log("Hidecontentmode: " + this.hideContentMode);
        if(this.hideContentMode){
           // console.log("Hide node: " + clickedNode.getContent());
            clickedNode.setHidden(!clickedNode.isHidden());
            this.draw();
            this.update();
            this.hideContentMode = false;
        }

        if (this.subNodeMode == false) {
            return;
        }

        let hiddenNodes = this.getHiddenNodes();

        this.nodes = [];
        this.edges = [];
        this.root = clickedNode;
        //console.log("New ROOT : " + this.root.getContent());

        this.buildTree();
        this.setHiddenNodes(hiddenNodes);
        this.update();

        this.subNodeMode = false;
    }

    update() {
        if (this.activ) {
            super.update();
        }
    }
    rightClick() {

    }

    equalContent(content1: any[], content2: any[]):boolean{
        if(content1 == null || content2 == null){
            return false;
        }
        if(content1.length != content2.length){
            return false;
        }

        for(let i = 0; i < content1.length; i++){
            if(!(content1[i] == content2[i])){
                return false;
            }
        }
        return true;
    }
}
